var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStyleGuides = function SvgStyleGuides(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "M65 15H35c-5.523 0-10 4.477-10 10v70c0 5.523 4.477 10 10 10h50c5.523 0 10-4.477 10-10V45L65 15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#68ADFF",
    d: "M65 45V15l30 30H65Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40 65a5 5 0 0 1 5-5h30a5 5 0 0 1 0 10H45a5 5 0 0 1-5-5ZM40 85a5 5 0 0 1 5-5h30a5 5 0 0 1 0 10H45a5 5 0 0 1-5-5Z"
  })));
};
export default SvgStyleGuides;